import React from 'react'

function ProgressBar({progress, url}) {

    return !url ?(
        <div>
            <div className="h-1 w-full  mt-16 rounded-full bg-gradient-to-r from-blue-500 to-blue-900  mt-2" style={{width: progress + '%'}}></div>
        </div>
    ) : (<></>)
}

export default ProgressBar
